// extracted by mini-css-extract-plugin
module.exports =  {"tag":"_93444fe79c--tag--uW7FJ","tag_close":"_93444fe79c--tag_close--jS45G"};